import React, { useState, useEffect } from 'react';
import "./SalesEffectiveness.css"
import SalesTologyFooter from '../SalesTologyFooter/SalesTologyFooter';
import Navbar from '../Navbar/Navbar';
import image5 from "../../assests/salestology-img05-1024x683.webp"
const SalesEffectiveness = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <div className="sales-container" style={{ marginTop: '80px' }}>
        <div className="sales-header">Sales Effectiveness Consultancy</div>
        
        <div className={`sales-content ${isVisible ? 'visible' : ''}`}>
          <div className="sales-image">
            <img src={image5} />
          </div>
          
          <div className="sales-text">
            <h2 className="sales-title">Sales Effectiveness Consultancy</h2>
            
            <p className="sales-description">
              We use a pragmatic, efficient, and cost-effective methodologies to identify the areas for improvement that will yield the highest payoff.
            </p>
            
            <p className="sales-process">Our process includes:</p>
            
            <ul className="sales-list">
              <li>Comprehensive multi-layered surveys to identify key gaps and areas of strength.</li>
              <li>Prioritization of areas of focus to ensure a pragmatic and cost-effective implementation plan.</li>
              <li>Comprehensive journey map that is designed to align with the organizational ability to fund and desired speed of change.</li>
              <li>Change management plan.</li>
              <li>Oversee the execution of the transformation if needed.</li>
            </ul>
          </div>
        </div>
      </div>
      <SalesTologyFooter />
    </>
  );
};

export default SalesEffectiveness;